import { RootState } from '@dis/redux'

export const selectSearchWord = (state: RootState) => {
  return state.search.searchWord
}

export const selectResults = (state: RootState) => {
  return state.search.results
}
